import EmmitterRedirect from './EmitterRedirect';

export default EmmitterRedirect;
